var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"logo-container",on:{"click":_vm.resetOffer}},[_c('img',{staticClass:"logo",attrs:{"alt":"logo","src":_vm.src[_vm.selected]}})])]),_c('nav',[_c('lang-options'),_c('user-options')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }